"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCases = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "cc",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m1440 0v1892h-1440v-1892h1440z"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "cb",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m7.3967 6.5719 1.4109 1.3965-5.2375 5.0316-3.5701-3.4092 1.4323-1.3555 2.1378 2.0332 3.8266-3.6967zm10.603 2.793v1.9305h-8.0594v-1.9305h8.0594zm-10.603-9.3649 1.4109 1.3965-5.2375 5.0316-3.5701-3.4092 1.4323-1.3555 2.1378 2.0332 3.8266-3.6967zm10.603 2.793v1.9305h-8.0594v-1.9305h8.0594z"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "ca",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "m20.571 0v19.5h-20.571v-19.5h20.571z"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-700 -261)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        clipPath: "url(#cc)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(700 261)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(3 6)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              clipPath: "url(#cb)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                points: "0 0 18 0 18 13 0 13",
                fill: "#fff"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(-1.7143 -3.25)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  clipPath: "url(#ca)",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    points: "1.7143 3.25 19.714 3.25 19.714 16.25 1.7143 16.25"
                  })
                })
              })]
            })
          })
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCases')(IconCases);